import React from 'react';
import { connect } from 'react-redux';
import HeadBlock from '$/components/global/heading';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import './index.scss';
import {
  getIsCurrentUserCompanyPublicInfoAdminState,
  getIsCurrentUserBixbyComplianceAdminState,
  getIsCurrentUserCompanyMNPIInfoAdminState,
} from '$/store/profile/selectors';
import { Route, Routes, useMatch } from 'react-router-dom';
import NonMnpiClientDataSite from '$/pages/admin/client/client-detail/ClientDataSite/NonMnpiClientDataSite';
import MnpiClientDataSite from '$/pages/admin/client/client-detail/ClientDataSite/MnpiClientDataSite';
import HeadingTab from '$/components/global/headingTab';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';

interface IClientDataSiteProps {
  client?: Bixby.Models.Client;
  isLoading: boolean;
  profile?: Bixby.Models.Profile;
  isCompanyPublicInfoAdmin: boolean;
  isCompanyMNPIInfoAdmin: boolean;
  isBixbyComplianceAdmin: boolean;
  isBixbyComplianceEnabled: boolean;
}

const ClientDataSite: React.FC<IClientDataSiteProps> = props => {
  const { isCompanyPublicInfoAdmin, isCompanyMNPIInfoAdmin, isBixbyComplianceAdmin, isBixbyComplianceEnabled } = props;
  const match = useMatch('/admin/client/:clientId/*');
  const baseUrl = `/admin/client/${match?.params.clientId}/data-sites`;

  return (
    <React.Fragment>
      <section>
        <HeadBlock title={''}>
          {(!isBixbyComplianceEnabled || isCompanyPublicInfoAdmin || isBixbyComplianceAdmin) && (
            <HeadingTab title="Non Mnpi Client Data Sites" link={`${baseUrl}/non-mnpi`} />
          )}
          {isBixbyComplianceEnabled && (isCompanyMNPIInfoAdmin || isBixbyComplianceAdmin) && (
            <HeadingTab title="Mnpi Client Data Sites" link={`${baseUrl}/mnpi`} />
          )}
        </HeadBlock>
        <div>
          <Routes>
            {(!isBixbyComplianceEnabled || isCompanyPublicInfoAdmin || isBixbyComplianceAdmin) && (
              <Route path={'non-mnpi'} element={<NonMnpiClientDataSite />} />
            )}
            {isBixbyComplianceEnabled && (isCompanyMNPIInfoAdmin || isBixbyComplianceAdmin) && (
              <Route path={'mnpi'} element={<MnpiClientDataSite />} />
            )}
          </Routes>
        </div>
      </section>
    </React.Fragment>
  );
};

const mapDispatchToProps = () => ({});

const mapStateToProps = (state: AppState) => {
  const { isCompanyPublicInfoAdmin } = getIsCurrentUserCompanyPublicInfoAdminState(state);
  const { isCompanyMNPIInfoAdmin } = getIsCurrentUserCompanyMNPIInfoAdminState(state);
  const { isBixbyComplianceAdmin } = getIsCurrentUserBixbyComplianceAdminState(state);
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);

  return {
    client: state.clientState.currentClient,
    isLoading: state.clientState.isLoading,
    profile: state.profileState.profile,
    isCompanyPublicInfoAdmin,
    isCompanyMNPIInfoAdmin,
    isBixbyComplianceAdmin,
    isBixbyComplianceEnabled,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientDataSite);
